import { BankAccountDto } from "./../../../Types/Api/DTO/BankAccountDto";
import FieldDto from "../../../Types/Api/DTO/FieldDto";
import { FieldRange } from "../../../Types/Api/DTO/FieldRangeDto";
import { ConditionalFieldDto } from "../../../Types/Api/DTO/ConditionalField";

export const isLoignActions = (islogin: any) => {
  return async (dispatch: any) => {
    await dispatch({ type: "IS_LOGIN", payload: islogin });
  };
};
export const allParamsAction = (params: FieldDto[]) => {
  return async (dispatch: any) => {
    await dispatch({ type: "ALL_PARAMS", payload: params });
  };
};
export const allBanksAction = (params: BankAccountDto[]) => {
  return async (dispatch: any) => {
    await dispatch({ type: "ALL_BANKS", payload: params });
  };
};
export const selectedParamsAction = (params: FieldDto[]) => {
  return async (dispatch: any) => {
    await dispatch({ type: "SELECTED_PARAMS", payload: params });
  };
};
export const symboledParamsAction = (params: FieldRange[]) => {
  return async (dispatch: any) => {
    await dispatch({ type: "SYMBOLED_PARAMS", payload: params });
  };
};
export const conditionsParamsAction = (params: ConditionalFieldDto[]) => {
  return async (dispatch: any) => {
    await dispatch({ type: "CONDITION_PARAMS", payload: params });
  };
};
